import { render, staticRenderFns } from "./EvaluationRecord.vue?vue&type=template&id=63088656&scoped=true&"
import script from "./EvaluationRecord.vue?vue&type=script&lang=js&"
export * from "./EvaluationRecord.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationRecord.vue?vue&type=style&index=0&id=63088656&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63088656",
  null
  
)

export default component.exports